// Root component. A thin shell: hosts the QueryClientProvider so every
// screen (including future routed children) has access to the shared
// query cache, and hands the rest to TanStack Router via RouterProvider.
//
// Layout (AppShell, Toaster, devtools, 401 handling, error boundary)
// lives in `src/routes/__root.tsx` because the router root is the
// canonical layout owner for file-based routing. App.tsx intentionally
// stays minimal so the only React state above the router is the query
// cache.
//
// Why threading `context={{ queryClient }}` matters: the typed router
// context (declared in `src/routes/__root.tsx`) lets route loaders and
// beforeLoad guards read `context.queryClient` to invalidate / prefetch
// without re-importing the singleton.
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'

import { queryClient } from '@/lib/query-client'
import { router } from '@/router'

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} context={{ queryClient }} />
    </QueryClientProvider>
  )
}

export default App
